import Modal from "./Modal";

import SurveyEditor from "../editors/SurveyEditor";

const SurveyModal = ({
  surveyId,
  surveys,
  open,
  onClose,
  onSave,
  onDelete,
}) => {
  return (
    <Modal
      title={surveyId ? "survey_update" : "survey_new"}
      open={open}
      onClose={onClose}
    >
      <SurveyEditor
        surveyId={surveyId}
        surveys={surveys}
        onSave={onSave}
        onDelete={onDelete}
      />
    </Modal>
  );
};

export default SurveyModal;
